import { render } from "./503.vue?vue&type=template&id=595955da&scoped=true"
const script = {}

import "./503.vue?vue&type=style&index=0&id=595955da&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-595955da"

export default script